<div>
  <mat-form-field class="input-container" style="width: 100%;"  [formGroup]="group" [appearance]="appearance">
    <mat-label>{{label}}</mat-label>
    <input
      matInput
      [matAutocomplete]="auto"
      (keyup)="handleChange($event)"
      [placeholder]="placeholder"
      [formControl]="control"
    />
    <mat-icon class="preIcon search" matSuffix>search</mat-icon>
    <mat-error *ngIf="control.hasError('notFromList') && control.touched">{{ info.selectOption }}</mat-error>
  </mat-form-field>
  <mat-autocomplete autoActiveFirstOption
    #auto="matAutocomplete"
    style="margin-top: 30px; max-height: 600px"
    [displayWith]="displayFn"
  >
    <div *ngFor="let index of state?.indices || []" [hidden]="control.value.length === 0">
      <mat-option
        *ngFor="let option of index['hits']"
        [value]="option"
        (click)="onSelect(option)"
      >
        {{ option.full_name }}
      </mat-option>
    </div>
    <mat-option
      *ngFor="let option of hospitalStaticOptions"
      [value]="option"
      (click)="onSelect(option)"
      class="algolia-sac-static-options"
      [hidden] = "option.type === 'notAdmitted' || option.type === 'noHospitalisationRequired' || control.value.length === 0"
    >
      {{ option.full_name }}
    </mat-option>
  </mat-autocomplete>
</div>
